import { ContextMenu, ContextMenuItem, Id, isSuccess, useToasts } from "@dgs/core";
import { useQueryClient } from "@tanstack/react-query";
import { FC, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { eventUserRequestService } from "../../../shared/api/eventUserRequestService";

interface Props {
	eventRequestId: Id;
	openDeclineDrawer: () => void;
}

export const EventUserRequestOpenListContextMenu: FC<Props> = ({ eventRequestId, openDeclineDrawer }) => {
	const { t } = useTranslation();
	const queryClient = useQueryClient();
	const { showToast } = useToasts();

	const approve = useCallback(async () => {
		const result = await eventUserRequestService.approveRequest(eventRequestId);
		if (isSuccess(result)) {
			void queryClient.invalidateQueries({ queryKey: eventUserRequestService.openRequestsKey });
			void queryClient.invalidateQueries({ queryKey: eventUserRequestService.approvedRequestsKey });
			showToast({
				type: "success",
				title: t("Approved"),
				body: t("Event request is successfully approved"),
			});
		}
	}, [eventRequestId, queryClient, showToast, t]);

	return (
		<ContextMenu displayShortcutsAs="icon">
			<ContextMenuItem
				label={t("Approve")}
				action={approve}
				title={t("Approve")}
				iconSrc="/person_check.svg"
				shortcut="primary"
			/>
			<ContextMenuItem
				label={t("Decline")}
				action={openDeclineDrawer}
				title={t("Decline")}
				iconSrc="/person_cancel.svg"
				shortcut={true}
			/>
		</ContextMenu>
	);
};
